module.exports = __webpack_public_path__ + "static/tu2-8704fe7d39e12d19a57feab3930dcd8b.png";